import React, { useEffect } from "react";
import Routes from "./Routes";
import TokenExpiryAlert from './components/TokenExpiryAlert';
import NotificationProvider from './components/ui/NotificationProvider';
import { AuthProvider } from './contexts/AuthContext';
import AccountBrowserIsolation from './components/AccountBrowserIsolation';
import UserAppStateSync from './components/UserAppStateSync';
import MercadoLibreAccountSync from './components/MercadoLibreAccountSync';


function App() {
  useEffect(() => {
    // Configurar título de la aplicación
    document.title = "MercadoBulk";
    
    // Configurar favicon dinámicamente si es necesario
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = "/mercadobulk-bag.svg";
    }
  }, []);

  return (
    <AuthProvider>
                              <AccountBrowserIsolation />
<MercadoLibreAccountSync />
<UserAppStateSync />
<NotificationProvider>
        <TokenExpiryAlert />
        <div className="app-shell">
          <Routes />
        </div>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;